module.exports = __webpack_public_path__ + "img/arrows-rotate.2e31ee3b.svg";